import { Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { PaginationAdapter } from '@red/data-access';
import { UserRoleCreateDto, UserRoleUpdateDto } from '@shared/data-access/dto';
import { IUserRole } from '@shared/data-access/interfaces';
import { UserPermissionModel, UserRoleModel } from '@shared/data-access/models';
import { map, Observable } from 'rxjs';
import { IPermission } from '@shared/permission';

@Injectable({
  providedIn: 'root',
})
export class UserRoleApiService {
  static ROOT_POINT = 'settings/roles';
  static COMMON_POINT = 'settings/roles/roles-common';
  static PERMISSION_POINT = 'settings/permissions';

  constructor(private apiService: ApiService) {}

  create(data: UserRoleCreateDto): Observable<UserRoleModel> {
    return this.apiService.post(`${UserRoleApiService.ROOT_POINT}`, data).pipe(map((res: IUserRole) => UserRoleModel.fromJson(res) as UserRoleModel));
  }
  get(itemId: number): Observable<UserRoleModel> {
    return this.apiService.get(UserRoleApiService.ROOT_POINT + '/' + itemId).pipe(map(res => UserRoleModel.fromJson(res) as UserRoleModel));
  }
  update(id: number, data: UserRoleUpdateDto): Observable<any> {
    return this.apiService.patch(UserRoleApiService.ROOT_POINT + '/' + id, data, { excludeFields: [''] });
  }

  search(query = {}, option?: IApiOption): Observable<PaginationAdapter<UserRoleModel>> {
    return this.apiService.get(UserRoleApiService.ROOT_POINT, query, option).pipe(map(data => new PaginationAdapter(UserRoleModel, data)));
  }

  searchCommon(query = {}, option?: IApiOption): Observable<PaginationAdapter<UserRoleModel>> {
    return this.apiService.get(UserRoleApiService.COMMON_POINT, query, option).pipe(map(data => new PaginationAdapter(UserRoleModel, data)));
  }

  delete(id: number, option?: IApiOption): Observable<any> {
    return this.apiService.delete(UserRoleApiService.ROOT_POINT + '/' + id, option);
  }

  getAllPermission(query = {}, option?: IApiOption): Observable<PaginationAdapter<UserPermissionModel>> {
    return this.apiService.get(UserRoleApiService.PERMISSION_POINT, query, option).pipe(map(data => new PaginationAdapter(UserPermissionModel, data)));
  }

  getPermissionsByRoleId(id: number, query = {}, option?: IApiOption): Observable<UserPermissionModel[]> {
    return this.apiService
      .get(UserRoleApiService.ROOT_POINT + '/' + id + '/permissions', query, option)
      .pipe(map((data: IPermission[]) => data.map(item => UserPermissionModel.fromJson(item))));
  }

  assignPermissions(id: number, permissionIds: number[]): Observable<any> {
    return this.apiService.patch(UserRoleApiService.ROOT_POINT + '/' + id + '/permissions', { permissionIds }, { excludeFields: [''] });
  }
}
